export default class MatomoConfigService {
  private static instance: MatomoConfigService = new MatomoConfigService();

  private constructor() {}

  public static singleton(): MatomoConfigService {
    return this.instance;
  }

  private parameters: MatomoParameters;

  public initializeFromElement(element?: HTMLElement) {
    if (element) {
      this.parameters = element.dataset;
    }
  }

  public getParameters(): MatomoParameters {
    return this.parameters;
  }

  public areRequiredParametersPresent(): boolean {
    return !!this.parameters && !!this.parameters.matomoId && !!this.parameters.matomoUrl;
  }
}

export class MatomoParameters {
  public readonly matomoId?: string;
  public readonly matomoUrl?: string;
  public readonly userId?: string;
}
